import { Badge, Flex, NumberInput, Paper, Select, Text } from "@mantine/core";
import { Controller } from "react-hook-form";
import { flagStatuses } from "../../../../utils/vars";
import { PERIOD_OPTIONS, STATUS_COLOR } from "../constants";

const ConfigCard = ({ config, role, control }) => {
  const disabled = role !== "ADMIN";
  const statusLabel = flagStatuses[config.status] || config.status;

  return (
    <Paper bg="secondary.0" p="md" w={220}>
      <Flex direction="column" gap="sm">
        <Flex justify="space-between" align="center">
          <Text size="sm">Status</Text>
          <Badge color={STATUS_COLOR[config.status] || "gray.5"} variant="filled" radius="sm">
            {statusLabel}
          </Badge>
        </Flex>

        <Controller
          name={`configs.${config.id}.period`}
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              value={field.value ?? ""}
              onChange={(val) => field.onChange(val)}
              data={PERIOD_OPTIONS}
              label="Period"
              disabled={disabled}
              allowDeselect={false}
            />
          )}
        />

        <Controller
          name={`configs.${config.id}.count`}
          control={control}
          render={({ field }) => (
            <NumberInput
              {...field}
              value={field.value ?? ""}
              onChange={(val) => field.onChange(val === "" ? null : val)}
              label="Flags count"
              hideControls
              min={0}
            />
          )}
        />

        <Controller
          name={`configs.${config.id}.countPerPeriod`}
          control={control}
          render={({ field }) => (
            <NumberInput
              {...field}
              value={field.value ?? ""}
              onChange={(val) => field.onChange(val === "" ? null : val)}
              label="Count per period"
              disabled={disabled}
              hideControls
              min={0}
            />
          )}
        />
      </Flex>
    </Paper>
  );
};

export default ConfigCard;
